import React, { useState, useEffect } from "react";
import { Button, CircularProgress, makeStyles } from "@material-ui/core";
import { Form, useFormik, FormikProvider } from "formik";
import axios from "axios";
import { BsArrowLeftShort } from "react-icons/bs";
import MarkupCurrency from "./CcmodeSetupNew/FormEdit/MarkupCurrency";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import kycFormModel from "./CcmodeSetupNew/FormModel/kycFormModel";
import validationSchemaEditTax from "./CcmodeSetupNew/FormModel/validationSchemaEditTax";
import { toast } from "react-toastify";
import { TfiSave } from "react-icons/tfi";
import { isEqual } from "lodash";
import { useCCmodeSettingContext } from "../../../context/ccmodeSettingContext";
import { Skeleton } from "@material-ui/lab";
import UnSavedChangesPopUp from "../Popup/UnSavedChangesPopUp";
const { formId, formField } = kycFormModel;

const useStyles = makeStyles((theme) => ({
    saveBtn: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
}));

export default function CcmodeTaxSetting(props) {
    const classes = useStyles();

    const {
        activeKey,
        setIsFormChanged,
        showFormChangePopUp,
        setShowFormChangePopUp,
        nextKey,
        setNextKey,
        setActiveKey,
    } = useCCmodeSettingContext();

    const [taxinclusive, SetTaxInclusiveValidation] = useState(false);
    const currentValidationSchema = validationSchemaEditTax(taxinclusive)[0];

    useEffect(() => {
        if (props.ccmodesetting && props.ccmodesetting.TaxValue) {
            SetTaxInclusiveValidation(true);
        }
    }, [props.ccmodesetting]);

    function _handleSubmit(values, actions) {
        actions.setSubmitting(true);
        const formData = new FormData();

        if (props.userinfo.id) {
            formData.set("CustomerId", props.userinfo.id);
        }
        if (values.muti_currency) {
            formData.set("Currency", values.muti_currency);
        }

        if (values.hidePrice >= 0) {
            const hidePriceVal = values.hidePrice ? 1 : 0;
            formData.set("hidePrice", hidePriceVal);
            if (hidePriceVal === 1) {
                formData.set("displaybuybtn", 0);
                formData.set("cartNotification", 0);
                formData.set("allowCurrencyChange", 0);
                formData.set("TaxValue", 0);
                formData.set("TaxName", "");
                formData.set("allowedCurrencies", "");
            } else {
                if (values.displaybuybtn >= 0) {
                    formData.set("displaybuybtn", values.displaybuybtn ? 1 : 0);
                }
                formData.set(
                    "cartNotification",
                    values.cartNotification ? 1 : 0
                );
                formData.set(
                    "TaxValue",
                    values.taxinclusive ? values.tax_value : 0
                );
                formData.set(
                    "TaxName",
                    values.taxinclusive ? values.tax_name : ""
                );

                if (values.allowCurrencyChange) {
                    formData.set("allowCurrencyChange", 1);
                    formData.set(
                        "allowedCurrencies",
                        values.allowedCurrencies?.length > 0
                            ? values.allowedCurrencies.join(",")
                            : values.muti_currency
                    );
                } else {
                    formData.set("allowCurrencyChange", 0);
                    formData.set("allowedCurrencies", "");
                }
            }
        }

        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/insert-update-ccmode-setting`,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: formData,
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success(
                        "Your Client-Centric Mode Currency and Tax Setting Updated Successfully."
                    );
                    toast.success(
                        "Please login again in CC-Mode to see the changes."
                    );

                    handlePopUpOnSuccess();

                    setTimeout(() => {
                        const container = document.getElementById(
                            "themesetting"
                        );
                        if (container) {
                            container.scrollIntoView({
                                top: 0,
                                left: 0,
                                behavior: "smooth",
                            });
                        }
                    }, 100);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                }
            })
            .finally(() => actions.setSubmitting(false));
    }

    const [initialFormObj, setInitialFormObj] = useState({
        muti_currency: props.ccmodesetting?.Currency || "",
        tax_name: props.ccmodesetting?.TaxName || "",
        tax_value: props.ccmodesetting?.TaxValue || 0,
        hidePrice: props.ccmodesetting?.hidePrice || false,
        displaybuybtn: props.ccmodesetting?.displaybuybtn || false,
        cartNotification: props.ccmodesetting?.cartNotification || false,
        allowCurrencyChange: props.ccmodesetting?.allowCurrencyChange || false,
        allowedCurrencies: props.ccmodesetting?.allowedCurrencies
            ? props.ccmodesetting.allowedCurrencies.split(",")
            : [],
        taxinclusive: Boolean(props.ccmodesetting?.TaxValue),
    });

    const formik = useFormik({
        initialValues: initialFormObj,
        enableReinitialize: true,
        validationSchema: currentValidationSchema,
        onSubmit: _handleSubmit,
    });

    useEffect(() => {
        if (props.ccmodesetting) {
            const isMatched = isEqual(initialFormObj, formik.values);

            if (!isMatched) {
                setIsFormChanged(true);
            } else {
                setIsFormChanged(false);
            }
        }
    }, [formik.values]);

    function handlePopUpOnSuccess() {
        setInitialFormObj(formik.values);
        setIsFormChanged(false);
        setShowFormChangePopUp(false);
        if (nextKey) {
            setActiveKey(nextKey);
            setNextKey(null);
        }
    }

    if (!props.ccmodesetting) {
        return (
            <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
            </>
        );
    }

    return (
        <div className="row">
            <div className="col-12 ccmode-setting-sticky-header">
                <div className="setting-title pb-3 pt-2">
                    <span
                        className="cursor-pointer text-hover-primary small setting-title"
                        onClick={() => window.history.go(-1)}
                    >
                        <BsArrowLeftShort /> Back to dashboard
                    </span>
                </div>
                <div
                    className={`col-12 px-0 setting-title pb-5 border-bottom ${classes.cardHeader}`}
                >
                    <div className="d-flex flex-column">
                        <span>CCMODE CURRENCY & TAX SETTING</span>
                        <span className="small text-capitalize">
                            Configure pricing display, currency options, and tax rules for your Client Centric Mode.
                        </span>
                    </div>
                    <div>
                        <Button
                            disabled={formik.isSubmitting}
                            variant="contained"
                            color="primary"
                            className={classes.saveBtn}
                            onClick={formik.submitForm}
                        >
                            <TfiSave className="mr-3" size={13} />
                            {props.language.SETTING_PASSWORD_SAVE}
                            {formik.isSubmitting && (
                                <CircularProgress
                                    size={16}
                                    className={"ml-3"}
                                />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-4">
                <FormikProvider value={formik}>
                    <Form id={formId}>
                        <MarkupCurrency
                            formField={formField}
                            values={formik.values}
                            setFieldValue={formik.setFieldValue}
                            language={props.language}
                            ccmodesetting={props.ccmodesetting}
                        />
                    </Form>
                </FormikProvider>
            </div>
            <UnSavedChangesPopUp
                show={showFormChangePopUp && activeKey === "ccmodetax"}
                onClose={() => {
                    formik.resetForm();
                    setIsFormChanged(false);
                    setShowFormChangePopUp(false);
                    if (nextKey) {
                        setActiveKey(nextKey);
                        setNextKey(null);
                    }
                }}
                onCross={() => {
                    setShowFormChangePopUp(false);
                }}
                message="you have unsaved changes in currency and tax setting"
                handleSave={formik.submitForm}
            />
        </div>
    );
}
